export default __webpack_public_path__ + "static/0037-4b252e3c8d7847faf3e3a22e5172dd60.png";